"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeparatedRow = exports.CenteredRow = exports.Row = exports.LinkButton = exports.SmallButton = exports.NavigationButton = exports.SecondaryButton = exports.Button = exports.LegendItem = exports.Legend = exports.GridSpacer = exports.GridCard = exports.ContentGrid = exports.Grid = exports.TextComment = exports.Caption = exports.GraphSVG = exports.GraphLabel = exports.GraphSubTitle = exports.GraphTitle = exports.Italic = exports.Bold = exports.Li = exports.NavigationLink = exports.Navigation = exports.StrippedLink = exports.ButtonLikeA = exports.A = exports.Ingress = exports.PSmall = exports.DetailP = exports.PTight = exports.P = exports.LeadText = exports.TitleWithExtraContent = exports.SmallSubtitle = exports.SmallTitleContent = exports.SmallTitle = exports.SectionTitle = exports.ToolTitle = exports.PageTitle = exports.FullWidthContainer = exports.ContainerCard = exports.baseReactModalStyles = exports.DEFAULT_RADIUS = exports.PageContent = exports.WideTextContent = exports.TextContent = exports.UISection = exports.ArticleMain = void 0;
exports.ComplianceIcon = exports.TD = exports.TR = exports.SortableTH = exports.TH = exports.Table = exports.Figure = exports.SelectorLabel = exports.Selector = exports.GraphImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../theme");
const NavigationContext_1 = require("../contexts/NavigationContext");
exports.ArticleMain = styled_components_1.default.section `
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.UISection = styled_components_1.default.div `
  width: 100%;
  margin: ${theme_1.theme.spacing(4)} 0 ${theme_1.theme.spacing(5)} 0;
`;
exports.TextContent = styled_components_1.default.div `
  max-width: 640px;
  width: 100%;
`;
exports.WideTextContent = styled_components_1.default.div `
  max-width: 1220px;
  width: 100%;
`;
exports.PageContent = styled_components_1.default.div `
  width: 100%;
  max-width: 1400px;
  margin: ${theme_1.theme.spacing(3)} auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(4)};
  align-items: ${(p) => (p.align === "left" ? "flex-start" : "center")};
`;
exports.DEFAULT_RADIUS = "12px";
exports.baseReactModalStyles = {
    overlay: {
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
    },
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        minWidth: "280px",
        maxWidth: "640px",
        maxHeight: "80vh",
        overflow: "scroll",
    },
};
exports.ContainerCard = styled_components_1.default.div `
  max-width: ${(p) => (p.maxWidth ? `${p.maxWidth}px` : "1400px")};
  width: 100%;
  background-color: white;
  border-radius: ${exports.DEFAULT_RADIUS};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${theme_1.theme.spacing(5)};
  min-height: 400px;
  box-sizing: border-box;
  background-color: ${theme_1.theme.colors.grey(5)};
  min-height: 0;

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    border-radius: 0px;
    box-shadow: none;
  }
`;
exports.FullWidthContainer = styled_components_1.default.div `
  width: 100%;
  box-sizing: border-box;
`;
exports.PageTitle = styled_components_1.default.h1 `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  ${theme_1.theme.fontSize(3)};
  cursor: pointer;
`;
exports.ToolTitle = styled_components_1.default.h1 `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  ${theme_1.theme.fontSize(2)};
`;
exports.SectionTitle = styled_components_1.default.h2 `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  ${theme_1.theme.fontSize(1)};
  margin: 0 0 ${theme_1.theme.spacing(3)} 0;
  padding: 0 0 ${theme_1.theme.spacing(0)} 0;
  width: 100%;
  border-bottom: 1px solid ${theme_1.theme.colors.grey(4)};
`;
const TitleRowContainer = styled_components_1.default.div `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  margin: 0 0 ${theme_1.theme.spacing(2)} 0;
  padding: 0 0 ${theme_1.theme.spacing(0)} 0;
  width: 100%;
  border-bottom: ${(p) => p.showBorder ? `1px solid ${theme_1.theme.colors.grey(4)}` : "none"};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const SectionTitleContent = (0, styled_components_1.default)(exports.SectionTitle) `
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
`;
exports.SmallTitle = styled_components_1.default.h3 `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  ${theme_1.theme.fontSize(1)};
  padding: 0;
  margin: 0;
  width: 100%;
`;
exports.SmallTitleContent = (0, styled_components_1.default)(exports.SmallTitle) `
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
`;
exports.SmallSubtitle = styled_components_1.default.h4 `
  ${theme_1.theme.fontTitle};
  color: ${theme_1.theme.colors.blackText};
  ${theme_1.theme.fontSize(-1)};
  padding: 0;
  margin: 0;
  width: 100%;
  text-transform: uppercase;
`;
const SmallSubtitleContent = (0, styled_components_1.default)(exports.SmallSubtitle) `
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
`;
const TitleWithExtraContent = ({ titleLevel, children, extraContent, style, }) => {
    let titleContent;
    switch (titleLevel) {
        case "Section":
            titleContent = (0, jsx_runtime_1.jsx)(SectionTitleContent, { children: children });
            break;
        case "Small":
            titleContent = (0, jsx_runtime_1.jsx)(exports.SmallTitleContent, { children: children });
            break;
        case "SmallSubtitle":
            titleContent = (0, jsx_runtime_1.jsx)(SmallSubtitleContent, { children: children });
    }
    return ((0, jsx_runtime_1.jsxs)(TitleRowContainer, { showBorder: titleLevel === "Section", style: { ...style }, children: [titleContent, extraContent] }));
};
exports.TitleWithExtraContent = TitleWithExtraContent;
exports.LeadText = styled_components_1.default.p `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.blackText};
  margin: ${theme_1.theme.spacing(3)} 0 ${theme_1.theme.spacing(3)} 0;
  line-height: 1.6;
  max-width: 640px;
`;
exports.P = styled_components_1.default.p `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.blackText};
  margin: 0 0 ${theme_1.theme.spacing(3)} 0;
  line-height: 1.6;
  max-width: 640px;
  width: 100%;
`;
exports.PTight = (0, styled_components_1.default)(exports.P) `
  line-height: 1.2;
  margin: 0;
`;
exports.DetailP = (0, styled_components_1.default)(exports.P) `
  margin-bottom: ${theme_1.theme.spacing(0)};
`;
exports.PSmall = (0, styled_components_1.default)(exports.P) `
  ${theme_1.theme.fontSize(-1)};
  margin-bottom: ${theme_1.theme.spacing(0)};
`;
exports.Ingress = (0, styled_components_1.default)(exports.P) `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
`;
exports.A = styled_components_1.default.a `
  color: ${(p) => p.color ?? theme_1.theme.colors.blue};
  text-decoration: underline;
  text-decoration-color: ${(p) => p.color ?? theme_1.theme.colors.blue};

  &:active {
    text-decoration-color: ${theme_1.theme.colors.blackText};
  }
  &:visited {
    text-decoration-color: ${(p) => p.color ?? theme_1.theme.colors.blue};
  }
`;
exports.ButtonLikeA = styled_components_1.default.a `
  background-color: ${theme_1.theme.colors.blue};
  padding: ${theme_1.theme.spacing(0)} ${theme_1.theme.spacing(2)};
  color: white;
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  flex-grow: 0;
  flex-shrink: 1;
  text-align: center;
  justify-content: center;
  white-space: nowrap;
  display: inline-block;
  border-radius: 6px;
  border: 1px solid ${theme_1.theme.colors.blue};
  transition: all 0.18s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  text-decoration: none;

  & + & {
    margin-left: ${theme_1.theme.spacing(2)};
  }

  &:hover {
    background-color: ${theme_1.theme.colors.darkBlue};
    color: white;
  }
`;
exports.StrippedLink = (0, styled_components_1.default)(NavigationContext_1.LinkWithHistory) `
  text-decoration: none;
  text-decoration-thickness: 0;
  color: initial;
  flex-grow: 0;
  display: inline-block;
  position: relative;
  ${theme_1.theme.fontBold};
  cursor: pointer;
`;
exports.Navigation = styled_components_1.default.nav `
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme_1.theme.spacing(3)};
  row-gap: ${theme_1.theme.spacing(1)};
  padding: 0;
  margin-bottom: ${theme_1.theme.spacing(3)};
`;
exports.NavigationLink = (0, styled_components_1.default)(NavigationContext_1.LinkWithHistory) `
  color: ${(p) => (p.$selected ? theme_1.theme.colors.bluelink : theme_1.theme.colors.grey(2))};
  text-transform: uppercase;
  text-decoration: none;
  ${theme_1.theme.fontBold};

  &:visited {
    color: ${(p) => p.$selected ? theme_1.theme.colors.bluelink : theme_1.theme.colors.grey(2)};
  }
`;
exports.Li = styled_components_1.default.li `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.blackText};
  line-height: 1.6;
  margin-bottom: ${theme_1.theme.spacing(1)};
`;
exports.Bold = styled_components_1.default.span `
  ${theme_1.theme.fontBold};
`;
exports.Italic = styled_components_1.default.span `
  font-style: italic;
`;
exports.GraphTitle = styled_components_1.default.h4 `
  max-width: 640px;
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(0)};
  margin: ${theme_1.theme.spacing(3)} 0 ${theme_1.theme.spacing(1)} 0;
`;
exports.GraphSubTitle = styled_components_1.default.h5 `
  max-width: 640px;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  margin: 0 0 ${theme_1.theme.spacing(1)} 0;
`;
exports.GraphLabel = styled_components_1.default.text `
  ${theme_1.theme.fontBold};
`;
exports.GraphSVG = styled_components_1.default.svg `
  margin-top: ${theme_1.theme.spacing(2)};
`;
exports.Caption = styled_components_1.default.div `
  width: 100%;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.darkBlue};
`;
exports.TextComment = styled_components_1.default.span `
  color: red;
`;
exports.Grid = styled_components_1.default.div `
  display: grid;
  width: 100%;
  grid-template-columns: repeat(
    auto-fit,
    minmax(
      ${(p) => p.minCellWidth !== undefined ? `${p.minCellWidth}px` : "260px"},
      ${(p) => p.maxCellWidth !== undefined
    ? `${p.maxCellWidth}px`
    : p.full
        ? "100%"
        : "1fr"}
    )
  );
  grid-column-gap: ${theme_1.theme.spacing(4)};
  grid-row-gap: ${theme_1.theme.spacing(3)};
  margin: ${theme_1.theme.spacing(2)} 0;
  align-items: start;

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    grid-template-columns: 100%;
  }
`;
exports.ContentGrid = styled_components_1.default.div `
  display: grid;
  width: 100%;
  max-width: 100%;
  grid-template-columns: repeat(
    ${(p) => (p.$cols ? p.$cols : 3)},
    minmax(0, 1fr)
  );
  grid-column-gap: ${theme_1.theme.spacing(4)};
  grid-row-gap: ${theme_1.theme.spacing(3)};
  margin: 0;
  align-items: start;
  box-sizing: border-box;
  overflow-x: auto;

  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    grid-template-columns: repeat(
      ${(p) => Math.min(p.$cols ?? 3, 2)},
      minmax(0, 1fr)
    );
  }

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    grid-template-columns: 100%;
  }
`;
exports.GridCard = styled_components_1.default.div `
  background-color: white;
  border-radius: ${exports.DEFAULT_RADIUS};
  padding: ${theme_1.theme.spacing(3)};
  grid-column: span ${(p) => p.$cols ?? 1};
  overflow-x: auto;
`;
exports.GridSpacer = styled_components_1.default.div `
  height: 0;
`;
exports.Legend = styled_components_1.default.div `
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: ${theme_1.theme.spacing(4)};
`;
const LegendItemElement = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: ${theme_1.theme.spacing(2)};
  margin-top: ${theme_1.theme.spacing(1)};
  ${theme_1.theme.fontSize(-1)};
  ${theme_1.theme.fontLabelBold};
  color: ${(p) => (p.textColor ? p.textColor : theme_1.theme.colors.blackText)};
`;
const ColorMarker = styled_components_1.default.div `
  width: 12px;
  height: 12px;
  background-color: ${(p) => p.color};
  margin-right: ${theme_1.theme.spacing(0)};
  border-radius: 50%;
`;
const LegendItem = (props) => ((0, jsx_runtime_1.jsxs)(LegendItemElement, { textColor: props.textColor, children: [(0, jsx_runtime_1.jsx)(ColorMarker, { color: props.color }), (0, jsx_runtime_1.jsx)("div", { children: props.text })] }));
exports.LegendItem = LegendItem;
exports.Button = styled_components_1.default.button `
  background-color: ${theme_1.theme.colors.darkBlue};
  padding: ${theme_1.theme.spacing(0)} ${theme_1.theme.spacing(2)};
  color: white;
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  flex-grow: 0;
  flex-shrink: 1;
  text-align: center;
  justify-content: center;
  white-space: nowrap;
  display: inline-block;
  transition: all 0.18s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: none;

  & + & {
    margin-left: ${theme_1.theme.spacing(2)};
  }

  &:hover {
    background-color: ${theme_1.theme.colors.blue};
    color: white;
  }

  &:disabled {
    background-color: ${theme_1.theme.colors.grey(3)};
    border: 1px solid ${theme_1.theme.colors.grey(2)};
    color: ${theme_1.theme.colors.grey(2)};
    cursor: not-allowed;
  }
`;
exports.SecondaryButton = (0, styled_components_1.default)(exports.Button) `
  background-color: white;
  color: ${(p) => p.color ?? theme_1.theme.colors.darkBlue};
  border: none;

  &:disabled {
    background-color: white;
    color: ${theme_1.theme.colors.grey(2)};
    border: none;
  }
`;
exports.NavigationButton = styled_components_1.default.div `
  background-color: ${(p) => p.selected ? theme_1.theme.colors.darkBlue : "transparent"};
  padding: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(2)};
  color: ${(p) => (p.selected ? "white" : theme_1.theme.colors.darkBlue)};
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  flex-grow: 0;
  flex-shrink: 1;
  text-align: center;
  justify-content: center;
  white-space: nowrap;
  display: inline-block;

  & + & {
    margin-left: ${theme_1.theme.spacing(2)};
  }

  &:hover {
    background-color: ${theme_1.theme.colors.darkBlue};
    color: white;
  }
`;
exports.SmallButton = (0, styled_components_1.default)(exports.Button) `
  background-color: transparent;
  color: ${theme_1.theme.colors.darkBlue};
  padding: 2px 4px;
  ${theme_1.theme.fontNormal};
  border: none;
`;
const LinkButton = (props) => ((0, jsx_runtime_1.jsx)(exports.StrippedLink, { to: props.to, children: (0, jsx_runtime_1.jsx)(exports.Button, { children: props.children }) }));
exports.LinkButton = LinkButton;
exports.Row = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${(p) => (p.gap !== undefined ? theme_1.theme.spacing(p.gap) : "0")};
  ${(p) => p.$responsive
    ? `
    @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
      flex-direction: column;
    }
  `
    : ""}
`;
exports.CenteredRow = (0, styled_components_1.default)(exports.Row) `
  width: 100%;
  justify-content: center;
`;
exports.SeparatedRow = (0, styled_components_1.default)(exports.Row) `
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
exports.GraphImage = styled_components_1.default.img `
  width: 100%;
  ${(p) => (p.paddingTop ? `padding-top: ${p.paddingTop}px;` : "")}
`;
exports.Selector = styled_components_1.default.div `
  margin-top: ${theme_1.theme.spacing(2)};
  display: flex;
  width: 100%;
  ${theme_1.theme.fontSize(-1)};
  ${(p) => p.horizontal
    ? `
    flex-direcion: row;
    align-items: center;
  `
    : `
    flex-direction: column;
  `}
`;
exports.SelectorLabel = styled_components_1.default.label `
  width: ${(p) => (p.horizontal ? "auto" : "100%")};
  margin-${(p) => (p.horizontal ? "right" : "bottom")}: ${theme_1.theme.spacing(0)}};
  color: ${(p) => (p.disabled ? theme_1.theme.colors.grey(3) : theme_1.theme.colors.blackText)};
`;
exports.Figure = styled_components_1.default.figure `
  margin: 0 0 0 0;
  width: 100%;
`;
exports.Table = styled_components_1.default.table `
  overflow: scroll;
  width: 100%;
  border-spacing: 1px;
`;
exports.TH = styled_components_1.default.th `
  text-align: left;
  padding: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(3)};
  ${theme_1.theme.fontSize(-1)};
  background-color: ${theme_1.theme.colors.lightBlue};
  color: white;
  ${(p) => p.active
    ? `
    text-decoration: underline;
    cursor: pointer;  
  `
    : ""};

  &:first-child {
    border-top-left-radius: 4px;
  }
  &:last-child {
    border-top-right-radius: 4px;
  }
`;
const getSortSymbol = (sortDirection) => {
    switch (sortDirection) {
        case 1:
            return " ⏶";
        case -1:
            return " ⏷";
        default:
            return "";
    }
};
const SortableTH = ({ children, setSort, sortKey, sortDirection, }) => {
    const handleClick = (e) => {
        e.preventDefault();
        if (sortKey) {
            setSort(sortKey, sortDirection === undefined ? 1 : -1 * sortDirection);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(exports.TH, { onClick: handleClick, active: sortKey !== undefined, children: [children, getSortSymbol(sortDirection)] }));
};
exports.SortableTH = SortableTH;
exports.TR = styled_components_1.default.tr `
  &:nth-child(even) {
    background-color: ${theme_1.theme.colors.grey(4)};
  }
  &:last-child {
    td:first-child {
      border-bottom-left-radius: 4px;
    }
    td:last-child {
      border-bottom-right-radius: 4px;
    }
  }
  ${theme_1.theme.fontSize(-1)};
`;
exports.TD = styled_components_1.default.td `
  text-align: left;
  padding: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(3)};
  ${theme_1.theme.fontSize(-1)};
`;
exports.ComplianceIcon = styled_components_1.default.img `
  width: 16px;
  height: 16px;
  margin-right: ${theme_1.theme.spacing(1)};
`;
